








































import Vue from 'vue'
import Component from "vue-class-component"
import { customer } from '@/store'
import OrderProduct from '@/models/orderProduct'
import { productThumbUrl } from '@/utils/functions'
import { Prop } from 'vue-property-decorator'

@Component
export default class OrderProductsTable extends Vue {
  @Prop({default: true}) editable!: boolean
  @Prop() products!: Array<OrderProduct>
  // Корзина — снимком: при оплате картой её чистят ещё до ухода на кассу, и
  // таблица не должна опустеть на глазах. Заказ приходит после первого
  // рендера, поэтому products читаем живыми
  cart = customer.products

  customer = customer
  productThumbUrl = productThumbUrl

  get productsList() {
    return this.products || this.cart
  }

  get retailerPage() {
    return customer.retailerPage
  }
  
  orderProductChanged() {
    customer.setOrder(customer.order)
  }

  removeProduct(index: number) {
    customer.products.splice(index, 1)
    customer.setProducts(customer.products)
    this.$forceUpdate()
  }

  get total() {
    var _total = 0
    this.productsList.forEach((product: OrderProduct) => {
      if (product.price)
        _total += product.price * product.amount
    });
    return _total
  }
}
